import * as DocumentCategoryStoreActions from './document-category.actions';
import * as DocumentCategoryStoreSelectors from './document-category.selectors';
import * as DocumentCategoryStoreReducer from './document-category.reducer';

export { DocumentCategoryStoreActions, DocumentCategoryStoreSelectors, DocumentCategoryStoreReducer };
